export const articles = [
  {
    id: 1,
    movieId: 1,
    title: "流浪地球3",
    category: "sci-fi",
    year: 2026,
    rating: 9.2,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20with%20astronauts%20and%20planetary%20engines%20against%20cosmic%20backdrop%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20dark%20blue%20and%20orange%20tones%2C%20epic%20scale%20landscape%20orientation&width=400&height=600&seq=article-scifi-01&orientation=portrait",
    ogImageUrl: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20for%20The%20Wandering%20Earth%203%20cinematic%20atmosphere%20epic%20space&width=1200&height=630&seq=og-article-1&orientation=landscape",
    description: `太阳即将毁灭，威胁着整个太阳系的生命。人类联合政府启动了《流浪地球计划》，在地球表面建造了上万台行星发动机，推动地球逃离太阳系，前往4.2光年外的比邻星。这场长达2500年的宇宙流浪之旅，充满了未知的危险与挑战。

在前两部的基础上，《流浪地球3》将故事推向更加宏大的宇宙尺度。地球在穿越柯伊伯带时，遭遇了前所未有的危机。吴京饰演的刘培强再次挺身而出，与新一代的年轻宇航员们并肩作战。

影片不仅延续了前作的硬核科幻风格，更加入了更多关于人性、亲情与希望的深刻探讨。在浩瀚宇宙面前，人类的渺小与伟大在银幕上得到了完美的展现。`,
    director: "郭帆",
    actors: ["吴京", "刘德华", "李雪健", "王智", "宁理"],
    duration: "148分钟",
    publishDate: "2026-01-22",
    tags: ["科幻", "灾难", "冒险", "太空"],
    relatedMovies: [10, 8],
  },
  {
    id: 2,
    movieId: 2,
    title: "封神第二部",
    category: "action",
    year: 2026,
    rating: 8.8,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20epic%20film%20with%20ancient%20warriors%20in%20elaborate%20armor%20and%20mythical%20beasts%2C%20dramatic%20Chinese%20mythology%20aesthetic%2C%20golden%20and%20crimson%20color%20palette%2C%20theatrical%20landscape%20composition&width=400&height=600&seq=article-action-01&orientation=portrait",
    ogImageUrl: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20epic%20film%20Fengshen%20Part%202%20cinematic%20mythology%20golden%20atmosphere&width=1200&height=630&seq=og-article-2&orientation=landscape",
    description: `《封神第二部》延续第一部的宏大叙事，将故事推向更加激烈的冲突高潮。纣王的暴政日益加深，天下民不聊生。姜子牙携封神榜下山，开始了辅佐武王伐纣的伟大征程。

在第二部中，各路神仙妖魔纷纷登场，展开了一场震撼人心的正邪大战。费翔饰演的纣王与黄渤饰演的姜子牙之间的对手戏精彩纷呈，于适饰演的姬发则是整部电影的灵魂人物，展现了从少年到王者的蜕变之路。

导演乌尔善以其独特的视觉风格，将中国神话传说中的奇幻世界栩栩如生地呈现在大银幕上，精美的特效与深刻的人物刻画相得益彰。`,
    director: "乌尔善",
    actors: ["费翔", "黄渤", "于适", "陈坤", "袁泉"],
    duration: "156分钟",
    publishDate: "2026-02-10",
    tags: ["奇幻", "神话", "动作", "史诗"],
    relatedMovies: [9, 12],
  },
  {
    id: 3,
    movieId: 4,
    title: "你好，李焕英2",
    category: "comedy",
    year: 2026,
    rating: 8.5,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20comedy%20film%20with%20warm%20family%20scene%20in%20nostalgic%201980s%20Chinese%20setting%2C%20bright%20cheerful%20colors%2C%20soft%20lighting%2C%20heartwarming%20atmosphere%2C%20landscape%20orientation&width=400&height=600&seq=article-comedy-01&orientation=portrait",
    ogImageUrl: "https://readdy.ai/api/search-image?query=Chinese%20comedy%20film%20Hi%20Mom%202%20warm%20family%20nostalgic%20heartwarming%20cinematic&width=1200&height=630&seq=og-article-3&orientation=landscape",
    description: `继前作取得巨大成功后，贾玲再次自导自演，为观众带来了《你好，李焕英2》。这一次，故事从另一个角度展开，贾晓玲再次获得穿越机会，但她决定做出不同的选择。

影片延续了前作温暖治愈的基调，同时加入了更多喜剧元素。贾玲、张小斐、沈腾的黄金组合再次碰撞出令人捧腹的火花。在笑声背后，电影依然传递着对母爱的深深眷恋和对生活的积极态度。

这是一部能让全家人一起欢笑一起落泪的电影，用最朴实的方式讲出了最动人的故事。`,
    director: "贾玲",
    actors: ["贾玲", "张小斐", "沈腾", "陈赫"],
    duration: "132分钟",
    publishDate: "2026-05-01",
    tags: ["喜剧", "家庭", "温情", "穿越"],
    relatedMovies: [7, 6],
  },
  {
    id: 4,
    movieId: 8,
    title: "狂飙：黎明之前",
    category: "tv-series",
    year: 2026,
    rating: 9.5,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20scene%20with%20intense%20police%20confrontation%20in%20dark%20urban%20night%20setting%2C%20high%20contrast%20noir%20lighting%2C%20gritty%20realistic%20aesthetic%2C%20landscape%20orientation&width=400&height=600&seq=article-tv-01&orientation=portrait",
    ogImageUrl: "https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20The%20Knockout%20intense%20police%20noir%20cinematic%20gritty&width=1200&height=630&seq=og-article-4&orientation=landscape",
    description: `《狂飙：黎明之前》作为《狂飙》的续作，继续讲述安欣与黑恶势力斗争的精彩故事。在这场正邪较量中，更多隐藏在黑暗中的势力浮出水面，真相远比想象中更加复杂。

张译饰演的安欣在本季中面临着前所未有的挑战，而张颂文饰演的角色也有了更加深刻的转变。剧集以紧张刺激的节奏和扣人心弦的剧情，展现了扫黑除恶斗争的复杂性和艰巨性。

每一集都充满了悬念和反转，让观众欲罢不能。这不仅是一部关于正义与邪恶的电视剧，更是一部关于人性和选择的深刻作品。`,
    director: "徐纪周",
    actors: ["张译", "张颂文", "李一桐", "吴刚", "倪大红"],
    duration: "40集",
    publishDate: "2026-03-15",
    tags: ["犯罪", "悬疑", "扫黑", "剧情"],
    relatedMovies: [5, 3],
  },
  {
    id: 5,
    movieId: 12,
    title: "笑傲江湖之东方不败",
    category: "action",
    year: 2026,
    rating: 9.1,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20wuxia%20film%20with%20sword%20hero%20in%20flowing%20robes%20on%20mountain%20landscape%20with%20mist%2C%20dramatic%20Chinese%20ink%20painting%20style%2C%20red%20and%20black%20contrast%2C%20landscape%20orientation&width=400&height=600&seq=article-wuxia-01&orientation=portrait",
    ogImageUrl: "https://readdy.ai/api/search-image?query=Chinese%20wuxia%20film%20Swordsman%20East%20Invincible%20ink%20painting%20martial%20arts%20cinematic&width=1200&height=630&seq=og-article-5&orientation=landscape",
    description: `徐克导演倾力打造的《笑傲江湖之东方不败》是对金庸经典武侠小说的全新演绎。林青霞饰演的东方不败再次惊艳银幕，将角色的复杂性和魅力展现得淋漓尽致。

影片在保留原著精神的基础上，加入了更加现代化的叙事手法和视觉效果。李连杰饰演的令狐冲潇洒不羁，与东方不败之间复杂的情感纠葛成为整部电影最大的看点。

武打场面设计精妙绝伦，每一场打斗都是一场视觉盛宴。在江湖恩怨、儿女情长中，影片探讨了权力、自由与真爱的永恒主题。`,
    director: "徐克",
    actors: ["林青霞", "李连杰", "关之琳", "甄子丹"],
    duration: "128分钟",
    publishDate: "2026-06-18",
    tags: ["武侠", "经典", "动作", "爱情"],
    relatedMovies: [2, 9],
  },
  {
    id: 6,
    movieId: 6,
    title: "深海总动员",
    category: "animation",
    year: 2026,
    rating: 8.9,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20with%20colorful%20underwater%20ocean%20world%2C%20cute%20fish%20characters%20and%20coral%20reefs%2C%20vibrant%20blue%20and%20turquoise%20colors%2C%20magical%20lighting%2C%20landscape%20orientation&width=400&height=600&seq=article-animation-01&orientation=portrait",
    ogImageUrl: "https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20Deep%20Sea%20colorful%20underwater%20magical%20cinematic&width=1200&height=630&seq=og-article-6&orientation=landscape",
    description: `《深海总动员》是国产动画电影的又一力作，以精美绝伦的画面和温暖人心的故事征服了各个年龄段的观众。影片讲述了一条小丑鱼的冒险之旅，在寻找海洋之心的过程中收获了友谊和成长。

田晓鹏导演以其一贯的高水准制作，将海底世界描绘得绚丽多彩。每一帧画面都堪称艺术品，让人仿佛置身于奇妙的海底世界之中。

影片不仅适合小朋友观看，成年人也能从中找到共鸣。关于勇气、友情和环保的主题，让这部电影有了更深层次的意义。`,
    director: "田晓鹏",
    actors: ["杨幂", "黄渤", "周冬雨"],
    duration: "105分钟",
    publishDate: "2026-07-01",
    tags: ["动画", "冒险", "喜剧", "家庭"],
    relatedMovies: [4, 7],
  },
];

export const aboutData = {
  brandName: "丁香花影院",
  slogan: "您的专属在线影院，高清影视随心看",
  founded: "2018",
  description: "丁香花影院成立于2018年，是国内领先的在线视频点播平台。我们致力于为广大影迷提供最新、最全、最高清的电影电视剧资源，打造极致的在线观影体验。",
  mission: "让每个人都能轻松享受高品质的影视娱乐内容，是我们的初心和使命。",
  features: [
    { title: "海量资源", description: "涵盖动作、喜剧、科幻、恐怖、爱情、动画等多种类型的影视作品，片库持续更新中", icon: "ri-movie-2-line" },
    { title: "高清画质", description: "支持1080P至4K超高清画质，带给你影院级的视觉享受", icon: "ri-4k-line" },
    { title: "流畅播放", description: "采用先进的CDN加速技术，确保观影过程流畅无卡顿", icon: "ri-speed-up-line" },
    { title: "多端支持", description: "支持电脑、平板、手机等多种设备，随时随地想看就看", icon: "ri-device-line" },
  ],
  testimonials: [
    { name: "影迷小王", content: "丁香花影院是我用过最好用的在线影院，画质清晰，更新速度快，强烈推荐！", rating: 5 },
    { name: "追剧达人", content: "在这里追完了整部《狂飙》，完全没有卡顿，体验太棒了！", rating: 5 },
    { name: "电影爱好者", content: "片库非常丰富，老片新片都能找到，而且都是高清版本。", rating: 5 },
    { name: "资深观众", content: "用了三年多了，界面简洁，操作方便，客服响应也很快。", rating: 4 },
  ],
  contact: {
    email: "contact@lilaccinema.com",
    wechat: "丁香花影院官方",
    qq: "1234567890",
    workingHours: "周一至周日 9:00 - 22:00",
  },
};